import type { PaymentType } from './types';
import { PAYMENT_TYPES } from './types';

const TOKENIZABLE_PAYMENT_METHODS: Readonly<PaymentType[]> = [
  'paywithgoogle',
  'googlepay',
  'applepay',
  'scheme',
  'bcmc',
];

const NOT_SUPPORT_MULTICARD_PAYMENT_METHODS: Readonly<PaymentType[]> = [
  'v12',
  'creditplus',
  'agos',
  PAYMENT_TYPES.OFFLINE,
  PAYMENT_TYPES.ORICO_FINANCING,
  PAYMENT_TYPES.SMBC,
];

// Compatible with all oney installment payment types, currently only facilitatepay_3 and facilitatepay_4 are used
export const oneyPaymentTypePattern = /^facilypay_(3|4|6|10|12)x$/;

export const checkIsOneyPaymentByType = (type?: PaymentType | null) =>
  !!type && oneyPaymentTypePattern.test(type);

export const isTokenizablePaymentMethod = (type: PaymentType | undefined) =>
  type && TOKENIZABLE_PAYMENT_METHODS?.includes(type);

export const isNotSupportMulticardPaymentMethod = (
  type: PaymentType | undefined | null,
) => !!type && NOT_SUPPORT_MULTICARD_PAYMENT_METHODS?.includes(type);
